import * as styles from "library/components/Footer/Footer.module.scss";
import {
  SVG_ESIC,
  SVG_ICON_FACEBOOK,
  SVG_ICON_INSTAGRAM,
  SVG_ICON_TWITTER,
  SVG_PLUS_18,
} from "assets/icons";
import React from "react";

const SocialIcons = () => (
  <div className={styles.social}>
    <a
      href="https://www.facebook.com/picklebet"
      target="_blank"
      rel="noopener noreferrer"
    >
      <SVG_ICON_FACEBOOK />
    </a>

    <a
      href="https://twitter.com/picklebet"
      target="_blank"
      rel="noopener noreferrer"
    >
      <SVG_ICON_TWITTER />
    </a>

    <a
      href="https://www.instagram.com/picklebet/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <SVG_ICON_INSTAGRAM />
    </a>

    <SVG_PLUS_18 />

    <a href="https://esic.gg/" target="_blank" rel="noopener noreferrer">
      <SVG_ESIC />
    </a>
  </div>
);

export default SocialIcons;
